import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 40 40" {...props}>
    <path
      d="M20.3,35.9c-7.9,0-14.4-6.4-14.4-14.4c0-7.9,6.4-14.4,14.4-14.4c7.9,0,14.4,6.4,14.4,14.4
      C34.6,29.4,28.2,35.9,20.3,35.9z M20.3,9.1c-6.8,0-12.4,5.5-12.4,12.4s5.5,12.4,12.4,12.4s12.4-5.5,12.4-12.4S27.1,9.1,20.3,9.1z"
    />
    <path
      d="M24.1,22.5c-0.5-1.2-1.5-2.1-2.9-2.3v-1v-0.4v-1.6c0.5,0.1,1.1,0.2,1.7,0.5c0.5,0.2,1.1-0.1,1.3-0.6
      c0.2-0.5-0.1-1.1-0.6-1.3c-0.9-0.3-1.7-0.5-2.4-0.6v-1.5c0-0.6-0.4-1-1-1s-1,0.4-1,1V15c-1.4,0.2-2.2,0.8-2.6,1.3
      c-0.9,1-1.1,2.5-0.4,3.7c0.6,1.1,1.7,1.8,3,2v3.2c-0.5-0.1-1-0.4-1.6-0.6c-0.5-0.3-1.1-0.1-1.3,0.4s-0.1,1.1,0.4,1.3
      c1,0.5,1.8,0.8,2.5,0.9v2.1c0,0.6,0.4,1,1,1s1-0.4,1-1v-2c1-0.2,1.7-0.6,2-0.9C24.3,25.5,24.6,23.9,24.1,22.5z M18,19.1
      c-0.2-0.4-0.3-1,0.1-1.5c0.1-0.1,0.5-0.4,1.1-0.5v1.7v0.4V20C18.7,19.9,18.2,19.6,18,19.1z M21.9,25c-0.2,0.2-0.4,0.3-0.7,0.4v-3
      c0.5,0.2,0.9,0.5,1,1C22.5,23.9,22.3,24.5,21.9,25z"
    />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/Billing.jsx